import { ModalConfirmation, notify, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { ModalId } from '../../../../enums/modalId'
import { NotificationKeys } from '../../../../enums/notificationKeys'
import { useEmberTransitionTo } from '../../../../hooks/routing/useEmberTransitionTo'
import { useDisableEInvoicing } from '../../hooks/useDisableEInvoicing'
import { getEInvoicingBaseUrl } from '../../utils/getEInvoicingBaseUrl'
import { DisableEInvoicingModalMessage } from '../EInvoicingDisableModalMessage'

export const EInvoicingDisableModal = ({
  shouldNavigateOnSuccess = true,
}: {
  shouldNavigateOnSuccess?: boolean
}): ReactElement => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { transitionTo } = useEmberTransitionTo()
  const { close } = useModal(ModalId.DisableEInvoicingModal)

  const { disableEInvoicing, isProcessing } = useDisableEInvoicing({
    onSuccess: () => {
      close()
      notify({
        id: NotificationKeys.EInvoiceDisablingSuccessful,
        message: t('disable_e_invoicing.notify.success'),
        variant: 'success',
      })
      if (shouldNavigateOnSuccess) {
        transitionTo(getEInvoicingBaseUrl(organization))
      }
    },
    onError: () => {
      notify({
        id: NotificationKeys.EInvoiceDisablingError,
        message: t('disable_e_invoicing.notify.error'),
        variant: 'error',
      })
      close()
    },
  })

  const handleDisable = useCallback(async () => {
    await disableEInvoicing()
  }, [disableEInvoicing])

  return (
    <ModalConfirmation
      cancelLabel={t('cancel')}
      danger
      id={ModalId.DisableEInvoicingModal}
      okLoading={isProcessing}
      message={<DisableEInvoicingModalMessage />}
      okLabel={t('receipts.side_panel.e_invoice_reception.deactivate')}
      onOk={handleDisable}
      title={t('disable_e_invoicing_modal.title')}
    />
  )
}
